// extracted by mini-css-extract-plugin
export var quantityInput = "_pi-0";